export default __webpack_public_path__ + "static/media/2re.b6295258.png";